import React from 'react';
import Fetch from '@components/util/Fetch';
import Icon from '@components/shared/icons';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import PropTypes from 'prop-types';
import './styles.scss';

const CALENDLY_WELCOME_URL = 'https://calendly.com/welcome-realestateagents/30min';

function TrialBanner({ data }) {
  const { dismissPath } = data;

  const handleClick = () => {
    logCrmEvent('trial_onboarding_banner_click');
    Fetch.post({ url: dismissPath });
    window.open(CALENDLY_WELCOME_URL, '_blank', 'noopener,noreferrer');
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    logCrmEvent('trial_onboarding_banner_dismiss');
    const banner = document.getElementById('trial-banner-content');
    banner.style.display = 'none';
    Fetch.post({ url: dismissPath });
  };

  return (
    <div
      id="trial-banner-content"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <button
        type="button"
        className="close-trial-button"
        onClick={handleClose}
      >
        <Icon type="close" />
      </button>

      <span className="trial-text large-bold-font">
        <Icon type="calendar" />
        Don't miss out on your referrals! Schedule your 15-minute welcome call now.
      </span>
      <button
        type="button"
        className="profile-edit-button submit"
      >
        SCHEDULE NOW
      </button>
    </div>
  );
}

TrialBanner.propTypes = {
  data: PropTypes.shape({
    dismissPath: PropTypes.string,
  }).isRequired,
};

export default TrialBanner;
